// extracted by mini-css-extract-plugin
export default {"container":"ParticipantFinishScreen_container__LMEdH","content":"ParticipantFinishScreen_content__NoaAK"};